import React, { useEffect } from "react";

const RedirectNow = () => {
    useEffect(()=> {
        window.location = process.env.PUBLIC_URL + "/regular-mutual-fund/funds/all";
    }, []);
}
export default RedirectNow;